import { MapPin, Ship, Clock } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";

export const ShippingRoutes = () => {
  const { routes } = useContent();
  return (
    <section id="routes" className="bg-white py-24" data-testid="routes-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading eyebrow={routes.eyebrow} title={routes.title} desc={routes.desc} />
        </Reveal>

        <div className="mt-14 grid gap-8 lg:grid-cols-2">
          <Reveal className="overflow-hidden rounded-2xl border border-gray-200 shadow-lg shadow-navy/10">
            <iframe
              title="Tema Port Ghana"
              src="https://www.google.com/maps?q=Tema+Port,+Ghana&output=embed"
              className="h-full min-h-[420px] w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="tema-port-map"
            />
          </Reveal>

          <div className="grid gap-4">
            {routes.items.map((r, i) => (
              <Reveal key={`${r.from}-${i}`} delay={i * 0.06}>
                <div
                  data-testid={`route-card-${i}`}
                  className="group flex items-center justify-between rounded-xl border border-gray-200 bg-white p-5 transition-all hover:border-navy/20 hover:shadow-md"
                >
                  <div className="flex items-center gap-4">
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy-50 text-navy">
                      <MapPin size={20} />
                    </span>
                    <div>
                      <p className="font-display font-bold text-navy">
                        {r.from} <span className="text-brandred">→</span> {r.to}
                      </p>
                      <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
                        <Clock size={13} /> Est. transit {r.days}
                      </p>
                    </div>
                  </div>
                  <Ship className="h-5 w-5 text-gold transition-transform group-hover:translate-x-1" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
